export const USER_DATA = 'USER_DATA'
export const USER_TOKEN = 'USER_TOKEN'
export const USER_SAVED_VACANCIES = 'USER_SAVED_VACANCIES'
export const USER_FOLDERS = 'USER_FOLDERS'
export const USER_RECRUITED = 'USER_RECRUITED'
export const USER_RECRUITED_CATEGORIES = 'USER_RECRUITED_CATEGORIES'
export const USER_RECRUITED_COMPANIES = 'USER_RECRUITED_COMPANIES'
export const TOGGLE_LOGIN_ALERT = 'TOGGLE_LOGIN_ALERT'
export const TOGGLE_LOGIN_MODAL = 'TOGGLE_LOGIN_MODAL'
export const TOGGLE_MENU_SIDEBAR = 'TOGGLE_MENU_SIDEBAR'
export const TOGGLE_USER_SIDEBAR = 'TOGGLE_USER_SIDEBAR'
export const TOGGLE_USER_EDIT_RESUME_TEXTAREA_DIALOG = 'TOGGLE_USER_EDIT_RESUME_TEXTAREA_DIALOG'
export const VACANCIES_LOADING = 'VACANCIES_LOADING'
export const VACANCIES_LOADING_TIMEOUT = 'VACANCIES_LOADING_TIMEOUT'
export const COMPANIES_LOADING = 'COMPANIES_LOADING'
export const COMPANIES_LOADING_TIMEOUT = 'COMPANIES_LOADING_TIMEOUT'
export const VACANCIES = 'VACANCIES'
export const VACANCY_ENTRY = 'VACANCY_ENTRY'
export const VACANCY_SIMILAR_VACANCIES = 'VACANCY_SIMILAR_VACANCIES'
export const COMPANIES = 'COMPANIES'
export const SIMILAR_COMPANIES = 'SIMILAR_COMPANIES'
export const COMPANY_ENTRY = 'COMPANY_ENTRY'
export const COMPANY_VACANCIES = 'COMPANY_VACANCIES'
export const MANIPULATOR_TOKEN = 'MANIPULATOR_TOKEN'
export const MANIPULATOR_DATA = 'MANIPULATOR_DATA'
export const MANIPULATOR_COMPANY = 'MANIPULATOR_COMPANY'
export const MANIPULATOR_COMPANIES = 'MANIPULATOR_COMPANIES'
export const MANIPULATOR_COMPANY_VACANCIES = 'MANIPULATOR_COMPANY_VACANCIES'
export const COMPANY_RECRUITED_RESUMES = 'COMPANY_RECRUITED_RESUMES'
export const COMPANY_RECRUITED_RESUME = 'COMPANY_RECRUITED_RESUME'
export const TOGGLE_VACANCY_CATEGORY = 'TOGGLE_VACANCY_CATEGORY'
export const TOGGLE_COMPANY_CATEGORY = 'TOGGLE_COMPANY_CATEGORY'
export const RESET_VACANCY_CATEGORY = 'RESET_VACANCY_CATEGORY'
export const RESET_COMPANY_CATEGORY = 'RESET_COMPANY_CATEGORY'
export const INITIALIZE_COMPANY_CATEGORY = 'INITIALIZE_COMPANY_CATEGORY'
export const INITIALIZE_VACANCY_CATEGORY = 'INITIALIZE_VACANCY_CATEGORY'
export const COMPANY_CATEGORIES = 'COMPANY_CATEGORIES'
export const VACANCY_CATEGORIES = 'VACANCY_CATEGORIES'
export const RESUME_DATA = 'RESUME_DATA'
export const RESUMES = 'RESUMES'
export const RESUME = 'RESUME'
export const RESUME_CHECKED = 'RESUME_CHECKED'
export const DRAFT_RESUME = 'DRAFT_RESUME'
export const ALL_RESUMES = 'ALL_RESUMES'
export const USER_AUTH_TOUCH_TIMESTAMP = 'USER_AUTH_TOUCH_TIMESTAMP'
export const COMPANY_AUTH_TOUCH_TIMESTAMP = 'COMPANY_AUTH_TOUCH_TIMESTAMP'



// WEBPACK FOOTER //
// ./src/vuex/mutation-types.js